import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { CheckoutSteps } from '../../types';
import { ServiceSummaryType } from '../../../ServiceSummary/types';
import { useTheme } from '../../../theme';
import { BaseButton } from '../../../BaseComponents';
import Money from '../../../Money';

interface Props {
	className?: string;
	type: CheckoutSteps;
	group: ServiceSummaryType;
	isPassed: boolean;
	isActive: boolean;
	isSelected: boolean;
	isPassengers?: boolean;
	onClick?: () => void;
}

const StepbarServiceSummary: React.FC<Props> = ({
	className,
	children,
	type,
	group,
	isPassed,
	isActive,
	isSelected,
	onClick
}) => {
	const { t } = useTranslation('MobileStepbar');
	const { StepbarServiceSummary: css } = useTheme('MobileStepbar');

	const isPassedOrActive = isPassed || isActive;
	const canChange = onClick && isPassedOrActive;

	return (
		<div className={cn(className, css.container)} data-step={type}>
			<div
				className={cn(css.header, {
					[css.disabled]: !isPassedOrActive
				})}
			>
				<span className={css.header__number} />
				<span className={css.header__icon}>{group.icon}</span>
				<span className={css.header__title}>{group.header}</span>
				{isPassedOrActive && isSelected && group.totalPrice?.amount > 0 && (
					<span className={css.header__price}>
						<Money money={group.totalPrice} />
					</span>
				)}
			</div>

			{isSelected && (
				<div className={css.content}>
					{children}
					{canChange && (
						<div className={css.footer}>
							<BaseButton variant="text" className={css.button} onClick={onClick}>
								{t('Change')}
							</BaseButton>
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default StepbarServiceSummary;
